module.exports = [additionalCodesService];

function additionalCodesService() {

    var service = {
        filterAntidumpingAdditionalCodes: filterAntidumpingAdditionalCodes,
        filterAndGroupOtherAdditionalTaricCodes: filterAndGroupOtherAdditionalTaricCodes,
        filterAndGroupNationalAdditionalCodes: filterAndGroupNationalAdditionalCodes,
        filterNationalAdditionalCodes: filterNationalAdditionalCodes,
        isAntidumpingAdditionalCode: isAntidumpingAdditionalCode,
        isDefaultAntidumpingAdditionalCode: isDefaultAntidumpingAdditionalCode,
        isOtherAdditionalTaricCode: isOtherAdditionalTaricCode,
        isNationalAdditionalCode: isNationalAdditionalCode
    };

    var antidumpingAdditionalCodeTypes = ['8', 'A', 'B', 'C'];
    var defaultAntidumpingAdditionalCodes = [ '8900', 'A999', 'B999', 'C999' ];
    var otherAdditionalTaricCodeTypes = ['2', '3', '4', '6', '9', 'G'];
    var nationalAdditionalCodeTypes = ['0', '1', '5', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];

    function filterAntidumpingAdditionalCodes(additionalCodes) {
        return additionalCodes.filter(isAntidumpingAdditionalCode);
    }

    function isAntidumpingAdditionalCode(additionalCode) {
        return antidumpingAdditionalCodeTypes.includes(additionalCode.type);
    }

    function isDefaultAntidumpingAdditionalCode(additionalCode) {
        return defaultAntidumpingAdditionalCodes.includes(additionalCode.type + additionalCode.code);
    }

    function isOtherAdditionalTaricCode(additionalCode) {
        return otherAdditionalTaricCodeTypes.includes(additionalCode.type);
    }

    function isNationalAdditionalCode(additionalCode) {
        return !antidumpingAdditionalCodeTypes.includes(additionalCode.type) && !otherAdditionalTaricCodeTypes.includes(additionalCode.type);
    }

    function filterAndGroupOtherAdditionalTaricCodes(additionalCodes) {
        var otherAdditionalTaricCodes = additionalCodes.filter(isOtherAdditionalTaricCode);
        var groupedCodes = groupAdditionalCodesByType(otherAdditionalTaricCodes);
        return groupedCodes;
    }

    function filterAndGroupNationalAdditionalCodes(additionalCodes) {
        var nationalAdditionalCodes = additionalCodes.filter(isNationalAdditionalCode);
        var groupedCodes = groupAdditionalCodesByType(nationalAdditionalCodes);
        return groupedCodes;
    }

    function groupAdditionalCodesByType(additionalCodes) {
        return _.chain(additionalCodes)
            .reduce(function(memo, additionalCode) {
                var codesOfType = _.find(memo, function(codesGroupedByType) {
                    return codesGroupedByType.type === additionalCode.type;
                });
                if (codesOfType === undefined) {
                    memo.push({
                        type: additionalCode.type,
                        codes: [ additionalCode ]
                    });
                }
                else {
                    codesOfType.codes.push(additionalCode);
                }
                return memo;
            }, [])
            .map(function(codeGroup) {
                codeGroup.codes = _.sortBy(codeGroup.codes, function(additionalCode) {
                    return additionalCode.type + additionalCode.code;
                });
                return codeGroup;
            })
            .value();
    }

    function filterNationalAdditionalCodes(additionalCodes) {
        return _.chain(additionalCodes)
            .filter(isNationalAdditionalCode)
            .sortBy(function (additionalCode) { return additionalCode.type + additionalCode.code; })
            .value();
    }

    return service;
}